import { render, staticRenderFns } from "./CollectionSettings.vue?vue&type=template&id=6e6fc306"
import script from "./CollectionSettings.vue?vue&type=script&lang=js"
export * from "./CollectionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports